﻿import Vue from "vue";
import DonneesReferentiellesVue = require("../vue/DonneesReferentiellesVue");
import common = require("../../common");
import utilities = require("../utilities");
import context = require("../context");
import SearchBox = require("../../core/SearchBox");
import HotEditableFormAction = require("../vue/hotEditable/HotEditableFormAction");

interface ISettings {
    enableSearchBox: boolean;
    searchBoxSettings: common.ISearchBoxSettings;
    dropdownUrl: string;
    dropdownSelectedItem: string;
}

class DonneesReferentielles implements common.IWebComponent {
    private _isInit = false;
    private _vueElId: string;
    private _vue: DonneesReferentiellesVue;
    private _searchBox: SearchBox;
    private _dropdownSelectedItem: string;
    private _dropdownUrl: string;
    //private _loader: Core.Loader;

    init(s: ISettings) {
        if (this._isInit)
            return;
        this._isInit = true;

        this._dropdownSelectedItem = s.dropdownSelectedItem || "";
        this._dropdownUrl = s.dropdownUrl;
        this._vueElId = "DonneesReferentiellesSummaryVue";

        this.setupVue(s);

        //this._loader = new Core.Loader(this._vueElId);

        this._searchBox = s.enableSearchBox
            ? new SearchBox(s.searchBoxSettings)
            : null;

        return context.components.add(this);
    }

    private setupVue(settings: any) {
        // Définition de Vue pour la partie Summary
        // NB: Les params sont passés ainsi car 'vue-class-component' ne permet pas de les passer par le ctor
        Vue.prototype.$initialData = {
            vueElId: this._vueElId,
            editModeOn: true
        };

        this._vue = new DonneesReferentiellesVue();
        this._vue.shared.setActionCallback(a => {
            this.onFormAction(a);
        });
    }

    private onFormAction(action: HotEditableFormAction) {
        if (!action.isFieldChanged)
            return;

        if (action.getFieldType() === common.HotEditableFieldTypes.select) {
            const id = action.getId();
            if (id === "RefStandardEntity") {
                const value = action.getFieldTextualValue();
                if (value !== this._dropdownSelectedItem) {
                    const url = this._dropdownUrl.replace("__name__", value);
                    utilities.redirect(url);
                    return;
                }
            }
        }
    }
}

export = DonneesReferentielles;
